import { required, email } from 'vuelidate/lib/validators'
import { isValidPhoneNumber } from 'libphonenumber-js'
import countries from '@/data/miscData/countries'

// Objeto do formulário
const schedulingType = [
  {
    name: 'consulta',
    value: 'CONSULTA'
  },
  {
    name: 'retorno',
    value: 'RETORNO'
  },
  {
    name: 'exame',
    value: 'EXAME_PROCEDIMENTO'
  }
]

const formData = {
  id: {
    value: null
  },
  appointmentStart: {
    value: null
  },
  appointmentFinish: {
    value: null
  },
  schedulingType: {
    value: 'CONSULTA',
    options: schedulingType
  },
  doctorOfficeMedicalService: {
    value: null
  },
  appointmentType: {
    type: 'radio',
    name: 'appointmentType',
    radios: [
      {
        label: 'Particular',
        value: 'PARTICULAR'
      },
      {
        label: 'Convênio',
        value: 'CONVENIO'
      },
      {
        label: 'Telemedicina',
        value: 'PARTICULAR_TELEMEDICINA'
      }
    ],
    value: null
  },
  value: {
    mask: '####',
    type: 'currency',
    name: 'value',
    placeholder: 'Valor',
    value: {
      converted: null,
      raw: 0
    }
  },
  referral: {
    type: 'search',
    name: 'referral',
    placeholder: 'Quem indicou?',
    endpoint: 'doctor/recommendation',
    format: '{$name}',
    returnFormat: '$name',
    fields: ['filterAndLike[r.name]'],
    value: null
  },
  note: {
    type: 'textarea',
    rows: 1,
    name: 'note',
    placeholder: 'Adicionar observação',
    value: null
  },
  specialPatient: {
    name: {
      type: 'text',
      value: null
    },
    email: {
      type: 'text',
      name: 'patient.email',
      placeholder: 'Endereço de e-mail',
      value: null
    },
    ddi: {
      type: 'select',
      name: 'patient.ddiContactPhone',
      placeholder: 'DDI',
      value: null,
      options: countries
    },
    telephone: {
      size: 4,
      type: 'text',
      name: 'patient.contactPhone',
      mask: ['(##) ####-####', '(##) #####-####'],
      placeholder: 'Telefone',
      value: null
    },
    cpf: {
      type: 'text',
      name: 'patient.cpf',
      placeholder: 'Número do CPF',
      mask: '###.###.###-##',
      value: null
    },
    rg: {
      type: 'text',
      name: 'patient.rg',
      placeholder: 'Número do RG',
      value: null
    },
    nationalHealthCard: {
      type: 'text',
      name: 'patient.nationalHealthCard',
      mask: '######################',
      placeholder: 'Cartão SUS',
      value: null
    },
    gender: {
      type: 'radio',
      name: 'patient.gender',
      radios: [
        {
          label: 'Feminino',
          value: 'F'
        },
        {
          label: 'Masculino',
          value: 'M'
        }
      ],
      value: null
    },
    birthdate: {
      type: 'text',
      name: 'patient.dateOfBirth',
      mask: '##/##/####',
      placeholder: 'Data de nascimento',
      value: null
    }
  },
  specialPatientHealthInsurance: {
    healthInsurance: {
      value: null
    },
    walletNumber: {
      value: null
    },
    walletValidity: {
      value: null
    }
  },
  address: {
    cep: {
      type: 'text',
      name: 'address.cep',
      placeholder: 'CEP',
      mask: '#####-###',
      value: null
    },
    city: {
      type: 'text',
      name: 'address.city.name',
      placeholder: 'Cidade',
      value: null,
      disabled: true
    },
    uf: {
      type: 'text',
      name: 'address.uf',
      placeholder: 'UF',
      value: null,
      disabled: true
    },
    district: {
      type: 'text',
      name: 'address.district',
      placeholder: 'Bairro',
      value: null,
      disabled: true
    },
    street: {
      type: 'text',
      name: 'address.street',
      placeholder: 'Rua',
      value: null,
      disabled: true
    },
    number: {
      type: 'text',
      name: 'address.number',
      placeholder: 'N.',
      value: null
    },
    complement: {
      type: 'text',
      name: 'address.complement',
      placeholder: 'Ap., conj.',
      value: null
    },
    latitude: {
      type: 'hidden',
      hide: true,
      name: 'address.latitude',
      value: null
    },
    longitude: {
      type: 'hidden',
      hide: true,
      name: 'address.longitude',
      value: null
    }
  },
  paymentMethod: {
    type: 'select',
    name: 'paymentMethod',
    placeholder: 'Pagamento',
    options: [
      {
        id: 1,
        name: 'Cartão de débito',
        value: 'CARTÃO DE DÉBITO',
        hidden: false
      },
      {
        id: 2,
        name: 'Cartão de crédito',
        value: 'CARTÃO DE CRÉDITO',
        hidden: false
      },
      {
        id: 3,
        name: 'Dinheiro',
        value: 'DINHEIRO',
        hidden: false
      },
      {
        id: 4,
        name: 'Cheque',
        value: 'CHEQUE',
        hidden: false
      },
      {
        id: 5,
        name: 'Boleto',
        value: 'BOLETO',
        hidden: false
      },
      {
        id: 6,
        name: 'Transferência Bancária',
        value: 'TRANSFERÊNCIA BANCÁRIA',
        hidden: false
      },
      {
        id: 7,
        name: 'PIX',
        value: 'PIX',
        hidden: false
      },
      {
        id: 8,
        name: 'Benefício Pré Pago',
        value: 'HEALTHPLACE PRÉ PAGO',
        hidden: true
      },
      {
        id: 9,
        name: 'Benefício Voucher',
        value: 'HEALTHPLACE PRÉ PAGO VOUCHER',
        hidden: true
      }
    ],
    value: null
  },
  receiptDate: {
    type: 'text',
    name: 'receiptDate',
    placeholder: 'Recebido em',
    mask: '##/##/####',
    value: null
  },
  paymentStatus: {
    value: 0
  },
  hasMedicalConsultationReturn: {
    value: false
  }
}

// Validações

const requiredIf = (property, condition, value) => {
  if (property === condition) {
    return !!value
  }

  return true
}

const validations = {
  appointmentStart: {
    value: {
      required
    }
  },
  appointmentFinish: {
    value: {
      required
    }
  },
  doctorOfficeMedicalService: {
    value: {
      requiredIf (value) {
        return requiredIf(this.formData.schedulingType.value, 'EXAME_PROCEDIMENTO', value)
      }
    }
  },
  value: {
    value: {
      required,
      isNotNull (value) {
        return ('converted' in value) ? (!!value.converted) : false
      }
    }
  },
  specialPatient: {
    name: {
      value: {
        required
      }
    },
    email: {
      value: {
        email,
        requiredIf (value) {
          return requiredIf(this.formData.appointmentType.value, 'PARTICULAR_TELEMEDICINA', value)
        },
        hasMedicalConsultationReturn (value) {
          return requiredIf(this.formData.hasMedicalConsultationReturn.value, true, value)
        }
      }
    },
    telephone: {
      value: {
        isValid (value) {
          if (value) {
            const iso = this.formData.specialPatient.ddi.value
            return isValidPhoneNumber(value, String(iso.toUpperCase()))
          }

          return true
        },
        requiredIf (value) {
          return requiredIf(this.formData.appointmentType.value, 'PARTICULAR_TELEMEDICINA', value)
        }
      }
    },
    cpf: {
      value: {
        isValid (value) {
          return this.fn_VALID_CPF(value)
        }
      }
    },
    rg: {
      value: {
        isValid (value) {
          if (value) {
            const onlyDigits = value.replace(/\D/gi, '')
            return !/^[^1-9]+$/gi.test(onlyDigits)
          }

          return true
        }
      }
    },
    birthdate: {
      value: {
        isValidDate (value) {
          if (value) {
            const date = this.$moment(value, 'DD/MM/YYYY', true)
            return date.isValid()
          }

          return true
        }
      }
    }
  },
  specialPatientHealthInsurance: {
    healthInsurance: {
      value: {
        requiredIf (value) {
          return requiredIf(this.formData.appointmentType.value, 'CONVENIO', value)
        }
      }
    },
    walletNumber: {
      value: {
        requiredIf (value) {
          return requiredIf(this.formData.appointmentType.value, 'CONVENIO', value)
        }
      }
    },
    walletValidity: {
      value: {
        requiredIf (value) {
          return requiredIf(this.formData.appointmentType.value, 'CONVENIO', value)
        },
        isValidDate (value) {
          if (value) {
            const date = this.$moment(value, 'DD/MM/YYYY', true)
            return date.isValid()
          }

          return true
        },
        isSameOrAfterToday (value) {
          if (value) {
            const now = this.$moment()
            const walletValidity = this.$moment(value, 'DD/MM/YYYY', true)
            return walletValidity.isSameOrAfter(now, 'd')
          }

          return true
        }
      }
    }
  },
  address: {
    cep: {
      value: {
        isValid (value) {
          if (value) {
            const regex = /(\d){5}-(\d){3}/
            return regex.test(value)
          }

          return true
        }
      }
    },
    street: {
      value: {
        requiredIf (value) {
          if (this.formData.address.cep.value) {
            return !!value
          }

          return true
        }
      }
    },
    number: {
      value: {
        requiredIf (value) {
          if (this.formData.address.cep.value) {
            return !!value
          }

          return true
        }
      }
    },
    district: {
      value: {
        requiredIf (value) {
          if (this.formData.address.cep.value) {
            return !!value
          }

          return true
        }
      }
    }
  },
  receiptDate: {
    value: {
      isValidDate (value) {
        const date = this.$moment(value, 'DD/MM/YYYY', true)
        return date.isValid()
      }
    }
  }
}

export { schedulingType, formData, validations }
